import { isInEffect } from '../utils/inEffect.js';
export const getContactName = (contact, { shouldValidate } = {}) => {
    const potentialNames = getContactPotentialNames(contact, { shouldValidate });
    // Duplicating this logic from getContactPotentialNames to make typescript happy
    if (!potentialNames?.length) {
        if (shouldValidate === false) {
            // TypeScript: Not sure why this is necessary, but it is
            return undefined;
        }
        else {
            throw new Error('Missing name of contact');
        }
    }
    const contactName = potentialNames[0];
    const surname = (contactName.familyName?.surname ?? '')
        ? (contactName.familyName?.surname ?? '')
        : `${contactName.familyName?.ownSurnamePrefix ?? '' + ' '}${contactName.familyName?.ownSurname ?? '' + ' '}${contactName.familyName?.surnamePrefixFromPartner ?? '' + ' '}${contactName.familyName?.surnameFromPartner ?? ''}`;
    const nameBuilder = {
        prefix: contactName.prefix ? contactName.prefix + ' ' : '',
        middleName: contactName.middleName ? contactName.middleName + ' ' : '',
        suffix: contactName.suffix ? ' ' + contactName.suffix : '',
        givenName: contactName.givenName,
        surname,
    };
    const buildName = (nameBuilder, order) => {
        if (order && order === 'Prefix Family Middle Given Suffix') {
            return `${nameBuilder.prefix}${surname + ' '}${nameBuilder.middleName}${nameBuilder.givenName}${nameBuilder.suffix}`;
        }
        else {
            return `${nameBuilder.prefix}${nameBuilder.givenName + ' '}${nameBuilder.middleName}${surname}${nameBuilder.suffix}`;
        }
    };
    return buildName(nameBuilder, contactName.nameAssemblyOrder).trim() || contactName.rawName;
};
export const getContactPotentialNames = (contact, { shouldValidate } = {}) => {
    const potentialNames = contact.name?.filter(isInEffect);
    if (!potentialNames?.length) {
        if (shouldValidate === false) {
            // TypeScript: Not sure why this is necessary, but it is
            return undefined;
        }
        else {
            throw new Error('Missing name of contact');
        }
    }
    return potentialNames;
};
